/**
 * @generated SignedSource<<31a4aa18d19a2c5dc7963d0db0ccf946>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespRelatedItem_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_item" | "SharedFavoriteItem_item" | "useFavoritesItem_item">;
  readonly " $fragmentType": "SharedRespRelatedItem_item";
};
export type SharedRespRelatedItem_item$key = {
  readonly " $data"?: SharedRespRelatedItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespRelatedItem_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Literal",
          "name": "showSeller",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFavoriteItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "c34b7d6d1d2deab37cc460ec484c62e0";

export default node;
